export default "__VITE_ASSET__DSFIWEzn__"